(function(){
  function makeHalftone(o){
    var w=o.w,h=o.h,g=o.grid||18,maxR=o.maxR||7,color=o.color||'#fff';
    var ox=(o.ox==null?1:o.ox),oy=(o.oy==null?1:o.oy),fade=o.fade||0.72;
    var c=document.createElement('canvas'); c.width=w; c.height=h;
    var ctx=c.getContext('2d'); ctx.fillStyle=color;
    var diag=Math.sqrt(w*w+h*h);
    for(var x=g/2;x<w+g;x+=g){
      for(var y=g/2;y<h+g;y+=g){
        var dx=x-ox*w,dy=y-oy*h;
        var d=Math.sqrt(dx*dx+dy*dy);
        var t=Math.max(0,1-d/(diag*fade));
        var r=maxR*t*t;
        if(r>0.4){
          var ix=(x/g)|0, iy=(y/g)|0;
          var sign=((ix+iy)%2===0)?1:-1;
          var rot=sign*(0.18+(((x*5+y*7)%5)-2)*0.04);
          var jx=(((x*3+y*5)%7)-3)*0.45;
          var jy=(((x*11+y*17)%7)-3)*0.45;
          ctx.save();
          ctx.translate(x+jx,y+jy);
          ctx.rotate(rot);
          ctx.fillRect(-r,-r,r*2,r*2);
          ctx.restore();
        }
      }
    }
    return c;
  }
  function paintTiles(){
    var tiles=document.querySelectorAll('.pg-category');
    tiles.forEach(function(tile){
      var old=tile.querySelector('.pg-cat-halftone');
      if(old) old.remove();
      var rect=tile.getBoundingClientRect();
      var w=Math.max(220,rect.width|0), h=Math.max(220,rect.height|0);
      var isLight=tile.classList.contains('pg-category--3')||tile.classList.contains('pg-category--4');
      var color=isLight?'#0B1F4D':'#FFFFFF';
      var canvas=document.createElement('canvas');
      canvas.className='pg-cat-halftone';
      canvas.width=w; canvas.height=h;
      canvas.style.width='100%'; canvas.style.height='100%';
      var made=makeHalftone({w:w,h:h,grid:22,maxR:8,color:color,ox:1,oy:1,fade:0.68});
      canvas.getContext('2d').drawImage(made,0,0);
      tile.insertBefore(canvas,tile.firstChild);
    });
  }
  function paintSection(selector, opts, corner){
    var sec=document.querySelector(selector);
    if(!sec) return;
    if(getComputedStyle(sec).position==='static') sec.style.position='relative';
    var existing=sec.querySelectorAll('.pg-section-halftone');
    existing.forEach(function(e){ e.remove(); });
    var w=opts.w||340, h=opts.h||340;
    var ox=corner.indexOf('r')>=0?1:0;
    var oy=corner.indexOf('b')>=0?1:0;
    var canvas=document.createElement('canvas');
    canvas.className='pg-section-halftone';
    canvas.width=w; canvas.height=h;
    var made=makeHalftone({w:w,h:h,grid:opts.grid||20,maxR:opts.maxR||7,color:opts.color||'#0B1F4D',ox:ox,oy:oy,fade:opts.fade||0.70});
    canvas.getContext('2d').drawImage(made,0,0);
    var pos = (ox?'right:0;':'left:0;') + (oy?'bottom:0;':'top:0;');
    canvas.style.cssText='position:absolute;pointer-events:none;z-index:0;opacity:'+(opts.opacity||0.06)+';'+pos;
    sec.appendChild(canvas);
  }
  function paintAllSections(selector, opts, corner){
    var sections=document.querySelectorAll(selector);
    sections.forEach(function(sec){
      if(getComputedStyle(sec).position==='static') sec.style.position='relative';
      var existing=sec.querySelectorAll('.pg-section-halftone');
      existing.forEach(function(e){ e.remove(); });
      var w=opts.w||340, h=opts.h||340;
      var ox=corner.indexOf('r')>=0?1:0;
      var oy=corner.indexOf('b')>=0?1:0;
      var canvas=document.createElement('canvas');
      canvas.className='pg-section-halftone';
      canvas.width=w; canvas.height=h;
      var made=makeHalftone({w:w,h:h,grid:opts.grid||20,maxR:opts.maxR||7,color:opts.color||'#0B1F4D',ox:ox,oy:oy,fade:opts.fade||0.70});
      canvas.getContext('2d').drawImage(made,0,0);
      var pos = (ox?'right:0;':'left:0;') + (oy?'bottom:0;':'top:0;');
      canvas.style.cssText='position:absolute;pointer-events:none;z-index:0;opacity:'+(opts.opacity||0.06)+';'+pos;
      sec.appendChild(canvas);
    });
  }
  function paintCorners(selector, opts){
    var sections=document.querySelectorAll(selector);
    sections.forEach(function(sec){
      if(getComputedStyle(sec).position==='static') sec.style.position='relative';
      var existing=sec.querySelectorAll('.pg-section-halftone');
      existing.forEach(function(e){ e.remove(); });
      var corners=['tl','br'];
      corners.forEach(function(corner){
        var w=opts.w||340, h=opts.h||340;
        var ox=corner.indexOf('r')>=0?1:0;
        var oy=corner.indexOf('b')>=0?1:0;
        var canvas=document.createElement('canvas');
        canvas.className='pg-section-halftone';
        canvas.width=w; canvas.height=h;
        var made=makeHalftone({w:w,h:h,grid:opts.grid||20,maxR:opts.maxR||7,color:opts.color||'#0B1F4D',ox:ox,oy:oy,fade:opts.fade||0.70});
        canvas.getContext('2d').drawImage(made,0,0);
        var pos = (ox?'right:0;':'left:0;') + (oy?'bottom:0;':'top:0;');
        canvas.style.cssText='position:absolute;pointer-events:none;z-index:0;opacity:'+(opts.opacity||0.06)+';'+pos;
        sec.appendChild(canvas);
      });
    });
  }
  function paintAll(){
    paintTiles();
    paintSection('.pg-hero', {color:'#0B1F4D', opacity:0.07, grid:20, maxR:7, w:380, h:380}, 'bl');
    paintSection('.pg-b2b-teaser', {color:'#FFD4A8', opacity:0.10, grid:20, maxR:8, w:400, h:400}, 'bl');
    paintSection('.pg-newsletter', {color:'#0B1F4D', opacity:0.06, grid:18, maxR:7, w:340, h:340}, 'bl');
    // PAGE HERO (over-ons, contact, maatwerk) - halftone in beide hoeken
    paintCorners('.pg-page-hero', {color:'#0B1F4D', opacity:0.08, grid:20, maxR:7, w:380, h:380});
    // 404 - halftone bottom-right
    paintSection('.pg-404', {color:'#0B1F4D', opacity:0.07, grid:20, maxR:7, w:360, h:360}, 'br');
    // SHOP / SPELLEN pagina:
    paintSection('.shop-hero', {color:'#0B1F4D', opacity:0.07, grid:20, maxR:7, w:380, h:380}, 'br');
    paintAllSections('.spread-lp', {color:'#0B1F4D', opacity:0.08, grid:18, maxR:7, w:320, h:320}, 'tr');
    paintAllSections('.spread-ts', {color:'#0B1F4D', opacity:0.08, grid:18, maxR:7, w:320, h:320}, 'bl');
    paintAllSections('.spread-gc', {color:'#FFD4A8', opacity:0.14, grid:20, maxR:8, w:380, h:380}, 'br');
    paintSection('.coming-section', {color:'#FFD4A8', opacity:0.10, grid:18, maxR:8, w:380, h:380}, 'bl');
    paintSection('.shop-newsletter', {color:'#FFD4A8', opacity:0.10, grid:18, maxR:7, w:340, h:340}, 'tr');
    // PRODUCT PAGINA - dubbele corners op pp-hero
    paintCorners('.pp-hero', {color:'#0B1F4D', opacity:0.10, grid:22, maxR:10, w:440, h:440});
    paintSection('.pp-detail', {color:'#FFD4A8', opacity:0.18, grid:18, maxR:7, w:320, h:320}, 'tr');
    paintSection('.pp-accessoires', {color:'#0B1F4D', opacity:0.08, grid:18, maxR:7, w:340, h:340}, 'br');
    // BLOG OVERVIEW pagina:
    paintCorners('.pb-hero', {color:'#0B1F4D', opacity:0.09, grid:20, maxR:8, w:360, h:360});
    paintSection('.pb-featured', {color:'#0B1F4D', opacity:0.06, grid:18, maxR:7, w:320, h:320}, 'tl');
    paintSection('.pb-topics', {color:'#FFD4A8', opacity:0.12, grid:20, maxR:8, w:400, h:400}, 'tr');
    paintSection('.pb-cta-banner', {color:'#0B1F4D', opacity:0.10, grid:18, maxR:8, w:340, h:340}, 'bl');
    // ARTIKEL pagina:
    paintSection('.pa-hero', {color:'#0B1F4D', opacity:0.08, grid:20, maxR:7, w:380, h:380}, 'tr');
    paintSection('.pa-related', {color:'#0B1F4D', opacity:0.05, grid:18, maxR:6, w:300, h:300}, 'br');
    // SPELUITLEG pagina:
    paintSection('.su-hero', {color:'#0B1F4D', opacity:0.07, grid:20, maxR:7, w:380, h:380}, 'br');
    paintAllSections('.su-game--peach', {color:'#0B1F4D', opacity:0.08, grid:18, maxR:7, w:320, h:320}, 'tr');
    paintAllSections('.su-game--mint', {color:'#0B1F4D', opacity:0.08, grid:18, maxR:7, w:320, h:320}, 'bl');
    paintAllSections('.su-game--orange', {color:'#FFD4A8', opacity:0.13, grid:20, maxR:8, w:360, h:360}, 'br');
  }
  function init(){ paintAll(); }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded',init);
  var rt;
  window.addEventListener('resize',function(){
    clearTimeout(rt); rt=setTimeout(paintAll,150);
  });
})();
